






























import { PermissionConfig } from '@empathybroker/tsclient-play/dist/models/instance/permission-config';

import Vue from 'vue';

import { DataTable, EpbSwitch, UiIconButton } from '../../components';

import { CONTAINER, TYPES } from '../../config';

import { AlignEnum, DomainEnum, FeatureIdEnum, PermissionLevelEnum } from '../../enums';

import { capitalizeSentence } from '../../filters';

import { FeatureNode, FeaturesTree } from '../../models';

interface PermissionDataItem {
  id: string;
  domain?: DomainEnum;
  featureId?: string;
  name: string;
  permissionLevel?: PermissionLevelEnum;
  isPermissionLevelInherited?: boolean;
  children?: PermissionDataItem[];
}

export default {
  name: 'permissions-form',
  props: {
    instance: {
      type: Object,
      required: true
    }
  },
  components: {
    DataTable,
    EpbSwitch,
    UiIconButton
  },
  computed: {
    featuresTree: function (): FeaturesTree {
      return CONTAINER.get<FeaturesTree>(TYPES.FeaturesTree);
    },
    data: function (): PermissionDataItem[] {
      return Object.entries(this.featuresTree).map(([domainStr, domainFeatureNodes]) => {
        let domain: DomainEnum;
        if ((Object.values(DomainEnum) as string[]).includes(domainStr)) {
          domain = (domainStr as DomainEnum);
        }
        return {
          id: domainStr,
          domain: domain,
          name: capitalizeSentence(!!domain ? this.$epb.messages.app.domains[domain] : this.$epb.messages.app.common),
          children: this.getFeaturesPermissionDataItems(domainFeatureNodes, domain)
        };
      });
    }
  },
  data: function () {
    const messages = this.$epb.messages.tools.instances.fields.permissions;
    return {
      columns: [
        {
          id: 'name',
          text: messages.feature.label
        }, {
          id: 'permissionLevel',
          text: messages.level.label,
          width: '12rem',
          align: AlignEnum.CENTER
        }
      ],
      expandedChildrenIds: [],
      messages: messages,
      PermissionLevelEnum
    };
  },
  methods: {
    getFeaturesPermissionDataItems: function (featureNodes: FeatureNode[], domain?: DomainEnum,
      parentPermissionLevel = PermissionLevelEnum.NONE): PermissionDataItem[] {
      return featureNodes.reduce((dataItems: PermissionDataItem[], featureNode: FeatureNode) => {
        if (featureNode.id !== FeatureIdEnum.ACCOUNT) {
          const permissionConfig = this.getFeaturePermissionConfig(featureNode.id, domain);
          const permissionLevel = (!!permissionConfig ? permissionConfig.level : parentPermissionLevel);
          dataItems.push({
            id: (!!domain ? `${domain}-${featureNode.id}` : featureNode.id),
            domain: domain,
            featureId: featureNode.id,
            name: capitalizeSentence(this.$epb.messages.app.features[featureNode.id] || featureNode.id),
            permissionLevel: permissionLevel,
            isPermissionLevelInherited: !permissionConfig,
            ...(!!featureNode.children &&
              { children: this.getFeaturesPermissionDataItems(featureNode.children, domain, permissionLevel) })
          });
        }
        return dataItems;
      }, []);
    },
    getFeaturePermissionConfig: function (featureId: string, domain?: DomainEnum): PermissionConfig {
      const domainPermissionConfigs = this.getDomainPermissionConfigs(domain);
      if (!!domainPermissionConfigs) {
        return domainPermissionConfigs.find((permissionConfig: PermissionConfig) => (permissionConfig.id === featureId));
      }
    },
    getDomainPermissionConfigs: function (domain?: DomainEnum): PermissionConfig[] {
      return (!!domain ? this.instance.permissions[domain] : this.instance.permissions.common);
    },
    onPermissionLevelChange: function (permissionDataItem: PermissionDataItem, permissionLevel: PermissionLevelEnum): void {
      const permissionConfig = this.getFeaturePermissionConfig(permissionDataItem.featureId, permissionDataItem.domain);
      if (!!permissionConfig) {
        permissionConfig.level = permissionLevel;
      } else {
        let domainPermissionConfigs = this.getDomainPermissionConfigs(permissionDataItem.domain);
        if (!!permissionDataItem.domain && !domainPermissionConfigs) {
          domainPermissionConfigs = Vue.set(this.instance.permissions, permissionDataItem.domain, []);
        }
        domainPermissionConfigs.push({
          id: permissionDataItem.featureId,
          level: permissionLevel
        });
      }
      this.expandPermissionDataItem(permissionDataItem);
    },
    expandPermissionDataItem: function (permissionDataItem: PermissionDataItem): void {
      if (!this.expandedChildrenIds.includes(permissionDataItem.id)) {
        this.expandedChildrenIds.push(permissionDataItem.id);
      }
    },
    onPermissionLevelRemove: function (permissionDataItem: PermissionDataItem): void {
      const domainPermissionConfigs = this.getDomainPermissionConfigs(permissionDataItem.domain);
      const indexOfPermissionConfig = domainPermissionConfigs.findIndex((permissionConfig: PermissionConfig) =>
        (permissionConfig.id === permissionDataItem.featureId));
      domainPermissionConfigs.splice(indexOfPermissionConfig, 1);
      this.expandPermissionDataItem(permissionDataItem);
    }
  },
  created: function (): void {
    this.expandedChildrenIds = Object.keys(this.featuresTree);
  }
};

